import { render, staticRenderFns } from "./Tasas.vue?vue&type=template&id=177b23cc"
import script from "./Tasas.vue?vue&type=script&lang=js"
export * from "./Tasas.vue?vue&type=script&lang=js"
import style0 from "./Tasas.vue?vue&type=style&index=0&id=177b23cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports